import type { Battery, ServiceIntervalConfig } from '../../types';
import { getServiceLifeRemaining } from '../getServiceLifeRemaining';

type BatterySoH = { available: false } | { available: true; percent: number };

// Derived State-of-Health for a battery pack (FR-09k). We have no live electricals
// backend, so SoH is derived honestly from cycle wear: percent = remaining service life
// against the configured battery cycle interval. This reuses getServiceLifeRemaining
// (which clamps to [0, 100] via getWearPercent), keeping usage/wear the single source of
// truth. When no cycle interval is configured, SoH cannot be derived → { available: false }.
export const getBatterySoH = ({
    battery,
    cycleInterval
}: {
    battery: Battery;
    cycleInterval?: ServiceIntervalConfig;
}): BatterySoH => {
    const serviceLife = getServiceLifeRemaining({
        interval: cycleInterval,
        usage: battery.cycleCount
    });

    if (!serviceLife.configured) {
        return { available: false };
    }

    return { available: true, percent: serviceLife.remaining };
};
